
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/set-pw",
      function () {
        return require("private-next-pages/set-pw.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/set-pw"])
      });
    }
  